export const VTMN_ALERT_TIMEOUT = 8000;

export const CSS_ANIMATION_TIME_MS = 700;

export const INFINITE_TIMEOUT_MS = 9999000;

export const VTMN_ALERT_VARIANT = {
  INFO: 'info',
  WARNING: 'warning',
  SUCCESS: 'success',
  DANGER: 'danger',
};
